import { useState, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { addInvoiceCredit } from "../../../services/invoices";
import { useMutation, useQueryClient } from "react-query";
import { getRandomIntInclusive } from "../../../helpers";
import { useGetAllChartOfAccounts } from "../../../hooks/api/queries";

const useCreditForm = ({
  invoiceDetails,
  closeWidget,
  billsDetails,
  supplierDetails,
  handleFetchInvoice = () => {},
}) => {
  const {
    isLoading: isLoadingBankAccountsList,
    data: bankAccounts,
    refetch: fetchBankAccountsList,
  } = useGetAllChartOfAccounts({
    sub_account_type: "cash_and_bank",
    supplier_id: supplierDetails?.id,
  });

  const [creditDetails, setCreditDetails] = useState({
    amount_paid: "",
    payment_method: "",
    ledger_account_id: invoiceDetails?.ledger_account_id || "",
    ledger_account_splits: [],
  });
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();

  const { mutate: addCredit, isLoading: isAddingCredit } = useMutation((data) =>
    addInvoiceCredit(data, invoiceDetails?.id),
  );
  const handleAddCredit = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = {
      amount_paid: creditDetails?.amount_paid,
      payment_method: creditDetails?.payment_method,
      ledger_account_id: creditDetails?.ledger_account_id,
    };
    addCredit(data, {
      onSuccess: () => {
        queryClient.invalidateQueries(["getSupplierInvoices"]);
        handleFetchInvoice();
        triggerToast("Payment added successfully", "success");
        closeWidget();
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  const submitCreditInfo = () => {
    handleAddCredit();
  };

  return {
    isAddingCredit,
    creditDetails,
    setCreditDetails,
    submitCreditInfo,
    bankAccounts,
    isLoadingBankAccountsList,
    fetchBankAccountsList,
  };
};

export default useCreditForm;
